import { gql } from '@apollo/client';

export const GET_USER_RESOURCE_ACCESS = gql`
  query getUserResourceAccess($userId: String!) {
    getUserResourceAccess(userId: $userId)
      @rest(
        type: "UserResourceAccess"
        path: "/users/{args.userId}/resources"
        endpoint: "admin"
      ) {
      organizations {
        id
        name
        participantType
      }
      binders {
        id
        name
        organization {
          id
          name
        }
        participantType
      }
      tenders {
        id
        name
        organization {
          id
          name
        }
        participantType
      }
    }
  }
`;

export type {
  ChildResourceAccess,
  OrganizationAccess,
  ParticipantType,
  UserResourceAccessResponse
} from './userResourceAccess.types';
